<template>
  <div>
    <el-card v-auth="'/agentSubjectCourse/pageList'">
      <el-row :gutter="20">
        <el-col :sm="24" :md="12" :lg="4">
          <el-input v-model="searchForm.name" placeholder="请输入app名称" auto-complete="off"></el-input>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4" style="float:right">
          <el-button style="float:right" type="primary" @click="pageList"  v-auth="'/agentSubjectCourse/pageList'"  icon="el-icon-search">查询</el-button>
          <!-- <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button> -->
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24">
        <el-col :span="12">
          <el-button type="primary" @click="addFormVisible = true" v-auth="'/agentSubjectCourse/addAgentApp'" icon="el-icon-plus">添加</el-button>
          <el-button type="primary" @click="addmainVisible = true" v-auth="'/agentSubjectCourse/addAgentMainApp'" icon="el-icon-plus">添加主APP</el-button>
          <!-- <el-button type="danger" @click="batchDeleteAgentApp" icon="el-icon-minus">批量删除</el-button> -->
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="agentName" label="机构名称"></el-table-column>
        <el-table-column prop="subjectCourseName" label=" 类型/科目"></el-table-column>
        <el-table-column prop="name" label="app名称"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="state"
          label="是否上架"
          align="center"
          width="80px"
        >
          <template slot-scope="row">
            <el-switch
              v-model="row.row.state"
              active-value="1"
              inactive-value="-1"
              @change="updateSwitching(row)"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="100" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span
                @click="selection = scope.row.id, editFormVisible = true"
                title="编辑"
                class="el-icon-edit icon-style"
                v-auth="'/agentSubjectCourse/updateAgentApp'"
              ></span>
              <!-- <span @click="deleteAgentApp(scope.row)">删除</span> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next, jumper,  total, sizes"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        :page-sizes="[10, 20, 30, 40]"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="添加主APP" :visible.sync="addmainVisible" width="30%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="app名称" prop="name">
            <el-input
              v-model="addForm.name"
              placeholder="请输入app名称"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="状态" prop="state">
            <el-radio v-model="addForm.state" label="1">上架</el-radio>
            <el-radio v-model="addForm.state" label="-1">下架</el-radio>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addmainVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAgentApp('app')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加" :visible.sync="addFormVisible" width="30%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="类型/科目" prop="courseId">
            <el-cascader
              style="width:100%"
              v-model="courseId"
              :options="subjectTreeList"
              @change="subjectChange"
              :props="subjectTreeProps"
              clearable
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="app名称" prop="name">
            <el-input
              v-model="addForm.name"
              placeholder="请输入app名称"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="状态" prop="state">
            <el-radio v-model="addForm.state" label="1">上架</el-radio>
            <el-radio v-model="addForm.state" label="-1">下架</el-radio>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAgentApp">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="editForm.courseId=='0'?'编辑主APP':'编辑'"
      :visible.sync="editFormVisible"
      width="30%"
      left
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item v-if="editForm.courseId!='0'" label="类型/科目" prop="courseId">
            <el-cascader
              style="width:100%"
              v-model="courseId"
              :disabled="true"
              :options="subjectTreeList"
              @change="subjectChange"
              :props="subjectTreeProps"
              clearable
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="app名称" prop="name">
            <el-input
              v-model="editForm.name"
              placeholder="请输入app名称"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="24" :lg="24">
          <el-form-item label="状态" prop="state">
            <el-radio v-model="editForm.state" label="1">上架</el-radio>
            <el-radio v-model="editForm.state" label="-1">下架</el-radio>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateAgentApp">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      blockAddAgentApp: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      subjectTreeProps: {
        value: "id",
        checkStrictly: true,
        label: "name",
        children: "children"
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      addmainVisible: false,
      searchForm: {
        name: ""
      },
      addForm: {
        courseId: "",
        name: "",
        state: "1"
      },
      addFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入类型/科目id",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "类型/科目id格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入app名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "app名称长度在1到255个字"
          }
        ]
      },
      editForm: {
        courseId: "",
        name: ""
      },
      editFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入类型/科目id",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "类型/科目id格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入app名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "app名称长度在1到255个字"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/agentApp/upload`,
      fileList: [],
      subjectTreeList: [],
      courseId: [],
      loading: false
    };
  },
  methods: {
    updateSwitching(row) {
      console.log(row.row.state);
      if (row.row.state == "1") {
        this.agentAppOn(row.row.id);
      } else {
        this.agentAppOff(row.row.id);
      }
    },
    agentAppOff(id) {
      this.api.agentApp
        .agentAppOff({ id: id })
        .then(result => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message
            });
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    agentAppOn(id) {
      this.api.agentApp
        .agentAppOn({ id: id })
        .then(result => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message
            });
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    subjectChange(val) {
      if (this.editFormVisible) {
        this.editForm.courseId = val[val.length - 1];
      } else this.addForm.courseId = val[val.length - 1];
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getAgentApp() {
      this.api.agentApp
        .getAgentApp({
          id: this.selection
        })
        .then(result => {
          result.data.state = result.data.state.toString();
          this.courseId = result.data.courseId;
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.agentApp
        .pageList(this.searchForm)
        .then(result => {
          result.data.records.forEach(element => {
            element.state = element.state.toString();
          });
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addAgentApp(val) {
      if (this.blockAddAgentApp) {
        return false;
      }
      this.blockAddAgentApp = true;
      if (val == "app") {
        this.$refs.addForm.validate(valid => {
          if (valid) {
            this.api.agentApp
              .addAgentApp({
                courseId: "0",
                name: this.addForm.name,
                state: this.addForm.state
              })
              .then(result => {
                if (result.success) {
                  this.addmainVisible = false;
                  this.pageList();
                  this.$message({
                    type: "success",
                    message: result.message
                  });
                  this.blockAddAgentApp = false;
                } else {
                  this.blockAddAgentApp = false;
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            return false;
          }
        });
      } else
        this.$refs.addForm.validate(valid => {
          if (valid) {
            this.api.agentApp
              .addAgentApp(this.addForm)
              .then(result => {
                if (result.success) {
                  this.addFormVisible = false;
                  this.$message({
                    type: "success",
                    message: result.message
                  });
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            return false;
          }
        });
    },
    updateAgentApp() {
      if(this.blockUpdateAgentApp){
        return false;
      }
      this.blockUpdateAgentApp = true;
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.agentApp
            .updateAgentApp(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.blockUpdateAgentApp = false;
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.blockUpdateAgentApp = false;
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteAgentApp(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.agentApp
            .deleteAgentApp([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteAgentApp() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.agentApp
            .deleteAgentApp(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.addForm = {
          courseId: "",
          name: "",
          state: "1"
        };
        this.courseId = [];
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getAgentApp();
      }
    }
  },
  mounted() {
    this.pageList();
    this.getSubjectTreeList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/agentApp/index.vue